module.exports = __webpack_public_path__ + "img/notification.d91e9014.svg";